/** Default TOEIC edition when URL has no year. Prefer the newest published year. */
export const DEFAULT_TOEIC_YEAR = '2027';
